(function () {

    angular
       .module('app')
       .controller('AdminController', AdminController);

    AdminController.$inject = [
        'authService', 'sitealertsService', '$scope', 'loggerService', 'qitanAiContractService'
    ];

    function AdminController(authService, sitealertsService, $scope, loggerService, qitanAiContractService) {

        var vm = this;
        vm.authService = authService;
        vm.loadingModelConfig = false;
        vm.savingModelConfig = false;
        vm.modelConfigMessage = '';
        vm.modelConfigError = '';
        vm.modelConfig = {};
        vm.modelConfigGroups = [];

        function getModelConfigValue(key) {
            if (!vm.modelConfigStatus ||
                !vm.modelConfigStatus.values ||
                !vm.modelConfigStatus.values[key])
            {
                return '';
            }
            return vm.modelConfigStatus.values[key].value || '';
        }

        function hydrateModelConfig(status) {
            vm.modelConfigStatus = status;
            vm.modelConfigGroups = status.groups || [];
            vm.modelConfig = {};
            vm.modelConfigGroups.forEach(function (group) {
                group.keys.forEach(function (item) {
                    vm.modelConfig[item.key] = getModelConfigValue(item.key);
                });
            });
        }

        function loadModelConfig() {
            vm.loadingModelConfig = true;
            vm.modelConfigError = '';
            return qitanAiContractService.getModelConfig()
                .then(hydrateModelConfig)
                .catch(function (err) {
                    vm.modelConfigError = '无法读取模型配置';
                    loggerService.error(err);
                })
                .finally(function () {
                    vm.loadingModelConfig = false;
                });
        }

        authService.getProfileDeferred()
            .then(function (profile) {
                vm.profile = profile;

                $scope.expiry = 1;
                $scope.url = '/#!/courses';
                $scope.severity = 'info';
                $scope.audience = 'public';

                if (profile.role === 'siteadmin') {
                    return loadModelConfig();
                }
            })
            .catch(loggerService.error);

        vm.confirm = function (newAlert) {
            newAlert.expiry = parseFloat(newAlert.expiry) * 3600000;
            sitealertsService.createAlert(newAlert)
                .then(function () {
                    alert('已添加站点通知');
                })
                .catch(loggerService.error);
        };

        vm.refresh = function () {
            sitealertsService.refreshServer().catch(loggerService.error);
        };

        vm.getConfigSource = function (key) {
            if (!vm.modelConfigStatus ||
                !vm.modelConfigStatus.values ||
                !vm.modelConfigStatus.values[key])
            {
                return '未配置';
            }

            var source = vm.modelConfigStatus.values[key].source;
            if (source === 'database') {
                return '后台配置';
            }
            if (source === 'environment') {
                return '环境变量';
            }
            return '未配置';
        };

        vm.saveModelConfig = function () {
            var values = {};

            vm.modelConfigGroups.forEach(function (group) {
                group.keys.forEach(function (item) {
                    values[item.key] = vm.modelConfig[item.key] || null;
                });
            });

            vm.savingModelConfig = true;
            vm.modelConfigMessage = '';
            vm.modelConfigError = '';

            return qitanAiContractService.saveModelConfig(values)
                .then(function (status) {
                    hydrateModelConfig(status);
                    vm.modelConfigMessage = '模型配置已保存';
                })
                .catch(function (err) {
                    vm.modelConfigError = err.data && err.data.error ?
                        err.data.error :
                        '保存模型配置失败';
                    loggerService.error(err);
                })
                .finally(function () {
                    vm.savingModelConfig = false;
                });
        };

        vm.reloadModelConfig = loadModelConfig;
    }
}());
